<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="edate"
        label="Birthday date"
        prepend-icon="mdi-cake-variant"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="edate"
      :active-picker.sync="activePicker"
      :max="
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      "
      min="1950-01-01"
      @change="save"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "BirthdayInput",
  created() {
    this.edate = this.date;
  },
  data: () => ({
    activePicker: null,
    edate: null,
    menu: false,
  }),
  methods: {
    save(date) {
      this.edate = date;
      this.$refs.menu.save(date);
      this.update("birthday", date);
    },
  },
  props: { date: String, update: Function },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },
};
</script>
